export default "__VITE_ASSET__DEj7gZkk__"